import { Overlay } from "@radix-ui/react-dialog";

export const DialogOverlay = Overlay;
